export const USER_ORDER_ERROR_ALREADY_EXIST = 'Error: The fields user, order must make a unique set.';
export const ROLE_CUSTOMER = 'CUSTOMER';